/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createFOAsyncThunk } from '../../helpers/thunk.helpers';
import draftApi from '../../../api/draft.api';
import { RoutePath } from '../../../shared/enums/RoutePath';
import history from '../../../history';
import { postProcessApi } from '../../../shared/configuration/businessRules.api';

export const saveSubmissionAndRedirect = createFOAsyncThunk('dialog/saveSubmissionAndRedirect', async (submission) => {
  const newSubmission = await draftApi.create(submission);
  const { id: submissionId, procedure } = await postProcessApi(newSubmission, 'event_new_draft_created');
  if (submissionId && procedure) {
    history.push(RoutePath.generateRoutePath(RoutePath.PROCEDURE_EDIT, { submissionId, procedure }));
  }
  return {};
});
